<app-ds-recent-search 
  [dataType]="dataType"
  [destination]="!!hotelSearch.isHotel ? hotelSearch.hotel_name : hotelSearch.destination | placeName | async"
  [startDate]="formatDate(hotelSearch.checkin)"
  [endDate]="formatDate(hotelSearch.checkout)"
  [paxNumber]="getHotelTravelers"
  [roomNumber]="getHotelRooms"
  [tooltipText]="getSimplePlaceName$(hotelSearch.destination) | async"
  [activateTooltip]="!isMobile"
  (clicked)="searchHotels()">
</app-ds-recent-search>